import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { get_contact, reset } from '../../features/contact/contactSlice'
import Loader from '../../components/Preloader'
import Pagination from '../../components/Pagination'
import { useLocation } from 'react-router-dom'

const DashboardContact = () => {
	const dispatch = useDispatch()
	const pageNumber = new URLSearchParams(useLocation().search).get('page') || 1

	const { loading, contacts } = useSelector((state) => state.postContact)

	const categoryHead = ['S/N', 'Name', 'Contact', 'Message']
	let i = 0

	useEffect(() => {
		dispatch(get_contact(pageNumber))

		return () => {
			dispatch(reset())
		}
	}, [dispatch, pageNumber])

	return (
		<section className='user_dashboard'>
			<div className='container'>
				{loading ? (
					<Loader />
				) : contacts && contacts.contacts && contacts.contacts.length > 0 ? (
					<>
						<div className='mt-5 table-responsive shadow-sm'>
							<table className='table table-bordered table-striped'>
								<thead className='' style={{ fontSize: '14px' }}>
									<tr>
										{categoryHead.map((cate, i) => (
											<th key={i}>{cate}</th>
										))}
									</tr>
								</thead>
								<tbody>
									{contacts.contacts.map((l, i) => (
										<tr key={l._id}>
											<td>{(contacts.meta.page - 1) * 10 + i + 1}</td>
											<td>{l.name}</td>
											<td>
												{' '}
												{l.email} <br /> {l.phone}{' '}
											</td>
											<td> {l.message} </td>
										</tr>
									))}
								</tbody>
							</table>
						</div>
						{contacts.meta.pages > 1 && (
							<>
								<Pagination
									currentPage={Number(contacts.meta.page)}
									totalCount={Number(contacts.meta.total)}
									pageSize={10}
									pathname={`/admin/dashboard/contact-entries`}
								/>
							</>
						)}
					</>
				) : (
					<div className='card mt-3'>
						<div className='card-body'>
							<p className='nothing'>No Contact us Entries found</p>
						</div>
					</div>
				)}
			</div>
		</section>
	)
}

export default DashboardContact
